import React from 'react'

interface TagListProps {
  tags: string[]
}

export const TagList: React.FC<TagListProps> = ({ tags }) => {
  if (tags.length === 0) {
    return <span style={{ color: 'var(--text-tertiary)', fontSize: 12 }}>—</span>
  }
  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
      {tags.map((t) => (
        <span key={t} className="eval-tag">{t}</span>
      ))}
    </div>
  )
}
